// material-ui
import Box from '@mui/material/Box';

export default function Footer() {
  return <Box sx={{ mt: 'auto', p: '24px 16px 0px' }} />;
}
